import { normalizeIndustrySector } from "../../domain/industry-sector";
import { mapApiAddressToAddress } from "./mapApiAddressToAddress";
export function mapApiOrganisationToOrganisation(api) {
    return {
        id: api.id,
        externalId: api.externalId ?? "",
        avatarUrl: api.logoUrl ?? null,
        status: api.status,
        createdAt: api.createdAt,
        updatedAt: api.updatedAt,
        tags: [],
        addresses: api.primaryAddress ? [{ ...mapApiAddressToAddress(api.primaryAddress), isPrimary: true }] : [],
        mainInformation: {
            legalName: api.legalName,
            acronym: api.acronym ?? "",
            tradeName: api.tradeName ?? null,
            organisationType: api.organisationType ?? "",
            relationTypes: [],
            industrySector: normalizeIndustrySector(api.industrySector),
            description: "",
        },
        administrativeInformation: {
            legalForm: api.legalForm ?? "",
            establishmentNature: api.establishmentNature ?? "",
            registrationDate: api.registrationDate ?? null,
            headcount: api.employeeCount ?? null,
            employeeRange: null,
            employeeRangeYear: null,
            siret: api.primaryRegistrationNumber ?? "",
            siretValidation: null,
            activityCode: api.activityCode ?? "",
            activityCodeLabel: "",
            vatNumber: "",
            vatValidation: null,
            turnover: api.turnover ?? null,
            legalStatus: api.legalStatus ?? null,
            parentOrganisationId: null,
            parentOrganisationName: null,
        },
        contactInformation: {
            phones: [],
            emails: [],
            domainName: api.website ?? null,
            socialLinks: [],
        },
    };
}
